export const ANIMATION = {
    duration: {
        fast: 0.15,
        normal: 0.2,
        slow: 0.3,
        extraSlow: 0.5,
    },
    spring: {
        damping: 20,
        stiffness: 300,
    },
    ease: [0.4, 0, 0.2, 1] as const,
} as const
